import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getServiceTypes(params: any): AxiosPromise {
    return EndPointService.get('/service_types', { params });
}

function getServiceTypesOrder(params: any): AxiosPromise {
    return EndPointService.get('/service_types/orders', { params });
}

function getServiceType(id: number | string): AxiosPromise {
    return EndPointService.get(`/service_types/${id}`);
}

function deleteServiceType(id: number | string): AxiosPromise {
    return EndPointService.delete(`/service_types/${id}`);
}

function createServiceType(payload: any): AxiosPromise {
    return EndPointService.post('/service_types', payload);
}

function updateServiceType(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/service_types/${id}`, payload);
}

export default {
    getServiceTypes,
    getServiceType,
    deleteServiceType,
    getServiceTypesOrder,
    createServiceType,
    updateServiceType,
};
